import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OrderService } from 'src/app/services/order/order.service';

declare var Stripe;

@Component({
  selector: 'app-stripe',
  templateUrl: './stripe.page.html',
  styleUrls: ['./stripe.page.scss'],
})
export class StripePage implements OnInit {
  stripe: any;
  card: any;
  orderData: any;
  stripeData: any;
  autoConfirm: any;
  constructor(private orderService: OrderService,
    private modalController: ModalController) { }

  ngOnInit() {
  }
  ionViewWillEnter() {
    this.stripe = Stripe(this.stripeData.publishableKey);
    this.setupStripe();
  }

  setupStripe() {
    let elements = this.stripe.elements();
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '24px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    this.card = elements.create('card', { style: style });
    console.log(this.card);
    this.card.mount('#card-element');

    this.card.addEventListener('change', event => {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  makePayment() {
    this.stripe.createSource(this.card).then(result => {
      if (result.error) {
        var errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
      } else {
        console.log(result);
        const data = {
          token: result.source.id,
          order: this.orderData
        }
        if(this.autoConfirm) {
          this.orderService.ac_payWithStripe(data);
        } else {
          this.orderService.payWithStripe(data);
        }
      }
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

}
